import { useState } from 'react';
import { useEntity } from '../../contexts/EntityContext';
import { WalletBalanceCards } from '../../components/cashier/WalletBalanceCards';
import { CreateOperationForm } from '../../components/cashier/CreateOperationForm';
import { TransactionHistoryTable } from '../../components/cashier/TransactionHistoryTable';

export default function CashierDashboardPage() {
  const { currentEntity } = useEntity();
  const [refreshKey, setRefreshKey] = useState(0);

  if (!currentEntity) return null;

  const handleTransactionSubmit = () => {
    setRefreshKey(prev => prev + 1);
  };

  return (
    <div className="min-h-screen bg-background p-4 md:p-8">
      <div className="max-w-7xl mx-auto space-y-6">
        {/* Wallet Balance Cards - Top Row */}
        <WalletBalanceCards refreshKey={refreshKey} />

        {/* Exchange Panel - Middle Section */}
        <CreateOperationForm onSubmit={handleTransactionSubmit} />

        {/* Transaction History - Bottom Section */}
        <TransactionHistoryTable refreshKey={refreshKey} />
      </div>
    </div>
  );
}
